var _path, _path2, _g, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCounterBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2364,
    height: 1440,
    viewBox: "0 0 2364 1440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2714_15030)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2714_15030)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_2714_15030_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.464382 0.0815232 0.0740844 0.332295 689.468 719.819)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1002.94,
    y: -1002.94,
    width: 2005.87,
    height: 2005.87
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(37, 137, 204, 1) 0deg,rgba(40, 131, 255, 1) 97.0608deg,rgba(0, 98, 232, 1) 181.478deg,rgba(37, 138, 202, 1) 220.621deg,rgba(47, 111, 227, 1) 267.566deg,rgba(37, 138, 202, 1) 355.293deg,rgba(37, 137, 204, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 0.5
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M639.664 430.665C586.886 452.792 542.975 482.722 490.178 504.817C417.115 535.394 319.709 533.604 269.304 585.659C218.173 638.462 186.795 721.084 227.742 775.838C272.472 835.653 414.437 798.807 469.2 852.965C528.002 911.118 449.319 1027.53 526.029 1070.83C593.534 1108.94 690.493 1046.03 771.913 1023.85C844.874 1003.98 935.612 998.527 978.887 947.487C1023.07 895.371 960.933 824.405 990.128 766.475C1021.01 705.197 1144.13 679.437 1146.7 614.514C1149.1 553.554 1051.24 526.401 1001.37 481.811C951.842 437.53 928.355 363.025 853.605 352.455C777.003 341.624 710.393 401.013 639.664 430.665Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.15833333134651184,\"g\":0.51512724161148071,\"b\":1.0,\"a\":1.0},\"position\":0.26961320638656616},{\"color\":{\"r\":0.0,\"g\":0.38682061433792114,\"b\":0.91250002384185791,\"a\":1.0},\"position\":0.50410437583923340},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.61283665895462036},{\"color\":{\"r\":0.18521772325038910,\"g\":0.43767693638801575,\"b\":0.89272087812423706,\"a\":1.0},\"position\":0.74323785305023193},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.98692411184310913}],\"stopsVar\":[{\"color\":{\"r\":0.15833333134651184,\"g\":0.51512724161148071,\"b\":1.0,\"a\":1.0},\"position\":0.26961320638656616},{\"color\":{\"r\":0.0,\"g\":0.38682061433792114,\"b\":0.91250002384185791,\"a\":1.0},\"position\":0.50410437583923340},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.61283665895462036},{\"color\":{\"r\":0.18521772325038910,\"g\":0.43767693638801575,\"b\":0.89272087812423706,\"a\":1.0},\"position\":0.74323785305023193},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.98692411184310913}],\"transform\":{\"m00\":-928.76483154296875,\"m01\":148.16885375976562,\"m02\":1079.7656250,\"m10\":163.04635620117188,\"m11\":664.59094238281250,\"m12\":306.0},\"opacity\":0.50,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2714_15030)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_angular_2714_15030_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.231857 0.0407029 0.0369889 0.165908 2013.84 959.611)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1005.88,
    y: -1005.88,
    width: 2011.77,
    height: 2011.77
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(37, 137, 204, 1) 0deg,rgba(40, 131, 255, 1) 97.0608deg,rgba(0, 98, 232, 1) 181.478deg,rgba(37, 138, 202, 1) 220.621deg,rgba(47, 111, 227, 1) 267.566deg,rgba(37, 138, 202, 1) 355.293deg,rgba(37, 137, 204, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 0.5
    }
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1988.98 815.243C1962.63 826.29 1940.7 841.234 1914.34 852.265C1877.86 867.532 1829.23 866.638 1804.07 892.628C1778.54 918.992 1762.87 960.243 1783.31 987.581C1805.65 1017.45 1876.53 999.049 1903.87 1026.09C1933.23 1055.12 1893.94 1113.25 1932.24 1134.87C1965.95 1153.89 2014.36 1122.48 2055.01 1111.41C2091.44 1101.49 2136.74 1098.77 2158.35 1073.28C2180.41 1047.26 2149.38 1011.83 2163.96 982.906C2179.38 952.311 2240.85 939.449 2242.13 907.035C2243.33 876.599 2194.47 863.042 2169.57 840.779C2144.84 818.67 2133.12 781.472 2095.8 776.194C2057.55 770.786 2024.29 800.438 1988.98 815.243Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.15833333134651184,\"g\":0.51512724161148071,\"b\":1.0,\"a\":1.0},\"position\":0.26961320638656616},{\"color\":{\"r\":0.0,\"g\":0.38682061433792114,\"b\":0.91250002384185791,\"a\":1.0},\"position\":0.50410437583923340},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.61283665895462036},{\"color\":{\"r\":0.18521772325038910,\"g\":0.43767693638801575,\"b\":0.89272087812423706,\"a\":1.0},\"position\":0.74323785305023193},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.98692411184310913}],\"stopsVar\":[{\"color\":{\"r\":0.15833333134651184,\"g\":0.51512724161148071,\"b\":1.0,\"a\":1.0},\"position\":0.26961320638656616},{\"color\":{\"r\":0.0,\"g\":0.38682061433792114,\"b\":0.91250002384185791,\"a\":1.0},\"position\":0.50410437583923340},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.61283665895462036},{\"color\":{\"r\":0.18521772325038910,\"g\":0.43767693638801575,\"b\":0.89272087812423706,\"a\":1.0},\"position\":0.74323785305023193},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.98692411184310913}],\"transform\":{\"m00\":-463.71371459960938,\"m01\":73.977745056152344,\"m02\":2208.7128906250,\"m10\":81.405784606933594,\"m11\":331.81698608398438,\"m12\":753.0},\"opacity\":0.50,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2714_15030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2092.75 1164.34C1857.05 1074.63 1804 939.839 1508.97 921.369C1213.93 902.899 862.439 559.164 623.719 499.494C384.999 439.823 149 512.861 -4 614.698L-4 1620L2368 1620L2368 1252.62C2368 1252.62 2328.44 1254.05 2092.75 1164.34Z",
    fill: "url(#paint2_linear_2714_15030)",
    fillOpacity: 0.3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2032.41 1050.55C1763.75 1014.8 1666.5 779.797 1270.92 793.947C875.341 808.096 694.033 603.138 395.699 603.138C97.3658 603.138 -4.00008 761.048 -4.00008 761.048L-4.00008 1636.14L2368 1636.14L2368 1006.14C2368 1006.14 2301.08 1086.3 2032.41 1050.55Z",
    fill: "url(#paint3_linear_2714_15030)",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2714_15030",
    x: -41.0723,
    y: 101.152,
    width: 1437.81,
    height: 1231.68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_2714_15030"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_2714_15030_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M639.664 430.665C586.886 452.792 542.975 482.722 490.178 504.817C417.115 535.394 319.709 533.604 269.304 585.659C218.173 638.462 186.795 721.084 227.742 775.838C272.472 835.653 414.437 798.807 469.2 852.965C528.002 911.118 449.319 1027.53 526.029 1070.83C593.534 1108.94 690.493 1046.03 771.913 1023.85C844.874 1003.98 935.612 998.527 978.887 947.487C1023.07 895.371 960.933 824.405 990.128 766.475C1021.01 705.197 1144.13 679.437 1146.7 614.514C1149.1 553.554 1051.24 526.401 1001.37 481.811C951.842 437.53 928.355 363.025 853.605 352.455C777.003 341.624 710.393 401.013 639.664 430.665Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2714_15030",
    x: 1523.92,
    y: 525.544,
    width: 968.23,
    height: 865.311,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_2714_15030"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_angular_2714_15030_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1988.98 815.243C1962.63 826.29 1940.7 841.234 1914.34 852.265C1877.86 867.532 1829.23 866.638 1804.07 892.628C1778.54 918.992 1762.87 960.243 1783.31 987.581C1805.65 1017.45 1876.53 999.049 1903.87 1026.09C1933.23 1055.12 1893.94 1113.25 1932.24 1134.87C1965.95 1153.89 2014.36 1122.48 2055.01 1111.41C2091.44 1101.49 2136.74 1098.77 2158.35 1073.28C2180.41 1047.26 2149.38 1011.83 2163.96 982.906C2179.38 952.311 2240.85 939.449 2242.13 907.035C2243.33 876.599 2194.47 863.042 2169.57 840.779C2144.84 818.67 2133.12 781.472 2095.8 776.194C2057.55 770.786 2024.29 800.438 1988.98 815.243Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2714_15030",
    x: -4,
    y: 478,
    width: 2372,
    height: 1142,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2714_15030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2714_15030",
    x1: 1205.27,
    y1: 506.478,
    x2: 1205.27,
    y2: 1279.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2714_15030",
    x1: 1243.81,
    y1: 603.138,
    x2: 1243.81,
    y2: 1320.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2714_15030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2364,
    height: 1440,
    fill: "white",
    transform: "matrix(-1 0 0 1 2364 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterBackground);
export default __webpack_public_path__ + "static/media/counterBackground.e7a543c6718a73522b3e7a0a61184849.svg";
export { ForwardRef as ReactComponent };